import React from 'react';
// @ts-expect-error type-lazyLoader
import { getLazyLoaderRenderFunction, lazyLoader } from '@/lib';
import { LoadingSpinnerFromIndexFile } from '../App/LoadingSpinnerFromIndexFile';

export const WPSLazyReceiptPage = lazyLoader({
  loader: () => import('./ReceiptPage'),
  loading: () => <LoadingSpinnerFromIndexFile />,
  name: 'ReceiptPage',
  render: getLazyLoaderRenderFunction({
    componentName: 'ReceiptPage',
  }),
});
